
































import { Component, Vue, Prop } from 'vue-property-decorator';
import ChangeRadio from '@/components/changeRadio/changeRadio.vue';
import FormDesign from '@/views/professionalWork/workflow/formDesign/formDesign.vue';
import ProcessDesign from '@/views/professionalWork/workflow/processDesign/processDesign.vue';
import BasicSetting from '@/views/professionalWork/workflow/basicSettings/unit/basicSetting.vue';
import { deepClone } from '@/util/deepClone';
import { institutionServer, processServe, userManagementServe } from '@/api/installServer';
import UserModule from '@/store/modules/user';

@Component({
  components: { ChangeRadio, FormDesign, ProcessDesign, BasicSetting },
})
export default class ProcessEdit extends Vue {
  @Prop() editData: any;
  showType = 1;
  equipmentType = '2';
  private workType: any = [
    {
      name: '基础设置',
      type: 1,
    },
    {
      name: '表单设计',
      type: 2,
    },
    {
      name: '流程设计',
      type: 3,
    },
  ];

  private allForm: any = {
    basic: {
      formData: {
        icon: '',
        name: '',
        groupName: '',
        desc: '',
        sponsor: '',
        admin: '',
        color: '#008bff',
        startAuthOrgMember: [],
      },
    },
    form: {},
    process: {},
  };

  private deptTree: any;
  private editMark: any = 'add';
  adminTree: any;

  async mounted() {
    if (this.editData) {
      this.editMark = 'edit';
      console.log(this.editData); // todo 转展示数据格式
      await this.getAdminTree();
      this.getBasicData();
      this.getFormData();
      this.getProcessData();
    }
    this.getList();
  }

  getAdminTree() {
    userManagementServe
      .sysAllUserList({
        size: 100,
        admin: true,
      })
      .then((res: any) => {
        this.adminTree = res.data.records;
        console.log(this.adminTree);
        // this.formIdToName();
      })
      .catch((error: any) => {});
  }

  idToName(id: any) {
    let name: any = '';
    console.log(this.adminTree);
    this.adminTree.forEach((admin: any) => {
      console.log(id);
      if (id === admin.id) {
        name = admin.username;
      }
    });
    return name;
  }

  getList(val?: any) {
    institutionServer
      .getAllDeptStaff({
        name: val ? val : null,
      })
      .then((res: any) => {
        this.deptTree = res.data.deptList;
        UserModule.setDeptTree(this.deptTree);
      })
      .catch((error: any) => {
        // this.$message.error('获取数据失败');
      });
  }

  getBasicData() {
    processServe
      .getProcessDataById(this.editData.id)
      .then((res: any) => {
        this.allForm.basic.formData = res.data;
        this.allForm.basic.formData.startAuthOrgMember = res.data.startMember;
        this.allForm.basic.formData.groupName = this.editData.groupName;
        const arr = res.data.editAuthStaffIds.split(',');
        const objArr: any = [];
        arr.forEach((item: any) => {
          objArr.push({
            objId: item,
            objName: this.idToName(item),
          });
        });
        this.allForm.basic.formData.admin = objArr; // 转换
        this.allForm.basic.type = 'basic';
        console.log(res);
      })
      .catch((e: any) => {});
  }

  getFormData() {
    processServe
      .getFromProcessDataById(this.editData.id)
      .then((res: any) => {
        console.log(res);
        this.allForm.form.formData = res.data;
        this.allForm.form.type = 'form';
        this.editForm(this.allForm.form.formData); // 进入页面后处理数据 解决点击标签才有数据问题 todo 测试
      })
      .catch((e: any) => {});
  }

  editForm(formData: any) {
    const arr: any = [];
    const map: any = {
      Input: 'CommonInput',
      Images: 'ImageInput',
      Text: 'TextareaInput',
      Radio: 'RadioInput',
      ContactPerson: 'ContactsInput',
      Location: 'PlaceInput',
      facilityList: 'Equipment',
      facilityStandredList: 'EquipmentStandard',
    };
    formData.forEach((item: any, index: any) => {
      const name = item.componentName;
      const type = map[name];
      formData[index].form = item.props;

      const el = document.getElementById('_unit_box');

      const props: any = {
        // unitId: this.incrementalId,
        formProp: item.props,
      };

      // const comp = create((this.unitBox as any)[type], props, el, 'bottom');
      //
      // comp.$on('i_close', (e: any) => {
      //   comp.remove();
      //   this.delUnitList(e);
      // });
      //
      // comp.$on('unit_set_data', (e: any) => {
      //   this.unitSetData(e);
      // });

      const data: any = {
        form: item.props,
        type: type,
        // id: this.incrementalId,
      };

      arr.push(data);

      // this.setData(data, 'push');

      // this.incrementalId++;
    });

    this.allForm.form.formData = arr;
  }

  getProcessData() {
    processServe
      .getFlowProcessDataById(this.editData.id)
      .then((res: any) => {
        console.log(res);
        this.allForm.process.formData = res.data;
        this.allForm.process.type = 'process';
        this.editProcess(deepClone(this.allForm));
      })
      .catch((e: any) => {});
  }

  editProcess(data: any) {
    const processConfig: any = {
      nodeConfig: {
        pid: '0',
        id: '0',
        type: 0,
        nodeName: '发起人',
        conditionNodes: [],
        conditionList: [],
        nodeUserList: [],
        formControlAuth: data.process.formData ? data.process.formData.start.formControlAuth : {},
      },
    };
    if (data.process.formData) {
      this.setDataForm(data.process.formData, processConfig);
    }
  }

  setDataForm(data: any, processConfig: any) {
    if (data.course.length > 0) {
      console.log(this.arrayToTree(data.course));
      // this.processConfig.nodeConfig.childNode = this.arrayToTree(data.course);
      this.$set(processConfig.nodeConfig, 'childNode', this.arrayToTree(data.course));
      console.log(processConfig);
      this.allForm.process.formData = processConfig;
    }
  }

  arrayToTree(list: any, callback: any = () => {}, props = { id: 'id', pid: 'pid', childNode: 'childNode' }) {
    let tree: any = {};
    const map: any = {};

    // list = cloneObj(list);

    console.log(list);
    const listLength = list.length;
    for (let i = 0; i < listLength; i++) {
      const node: any = list[i];

      if (node.type !== 1 && node.type !== 2 && node.type !== 3 && node.type !== 4) {
        // 节点类型转换
        const typeMap: any = {
          approve: 1,
          cope: 2,
          handle: 3,
          condition: 4,
        };
        node.nodeName = node.label;
        node.conditionNodes = [];
        node.conditionList = [];
        node.nodeUserList = [];

        const typeName = node.type;
        node.type = typeMap[typeName];
        console.log(node.type);

        if (node.conditionUnits && node.conditionUnits.length > 0) {
          node.conditionUnits.forEach((item: any, index: any) => {
            if (node.conditionUnits[index].flowNodes.length > 0) {
              node.conditionUnits[index].childNode = this.arrayToTree(node.conditionUnits[index].flowNodes);
            }
            node.conditionUnits[index].type = 5;
            node.conditionUnits[index].conditionNodes = [];
            node.conditionUnits[index].conditionList = [];
            node.conditionUnits[index].nodeUserList = [];
            node.conditionUnits[index].nodeName = item.name;
          });
        }

        node.conditionNodes = node.conditionUnits;
      }

      const nodeId: any = node[props.id];
      map[nodeId] = node;
      callback(node);
    }

    for (let i = 0; i < listLength; i++) {
      const node: any = list[i];
      const nodePid: any = node[props.pid];
      const parentNode: any = map[nodePid];
      if (parentNode) {
        parentNode[props.childNode] = parentNode[props.childNode] || {};
        parentNode[props.childNode] = node;
      } else {
        tree = node;
      }
    }

    return tree;
  }

  private async getCheck(data: any) {
    console.log(data);
    this.showType = data;
  }

  /**
   * @desc 切换pc、移动显示方式
   * @param type - 1pc 2移动
   */
  private equipmentTypeChange(type: any) {
    this.equipmentType = type;
    const refStr = 'formDesignRef';
    const ref: any = this.$refs[refStr];
    ref.equipmentTypeChange(type);
  }

  private back() {
    this.$emit('back');
  }

  private setData(data: any) {
    if (data.type === 'basic') {
      this.allForm.basic = data;
    }
    if (data.type === 'form') {
      this.allForm.form = data;
    }
    if (data.type === 'process') {
      this.allForm.process = data;
    }
    console.log(this.allForm);
  }

  treeToArr(tree: any, arr: any, type: number, pid: any): any {
    // type 1 外层流程  type 2 条件内部的流程
    console.log(type);
    if (type === 1) {
      arr = {
        start: arr.start || {},
        course: arr.course || [],
      };
      if (tree.type === 0) {
        // 处理开始流程
        arr.start.formControlAuth = tree.formControlAuth;
      } else {
        tree.pid = pid;
        arr.course.push(this.dataTransform(tree.type, tree));
      }
    }
    if (type === 2) {
      if (tree.type === 5) {
        arr = {
          // conditionGroups: [],
          // flowNodes: arr.flowNodes || [],
          flowNodes: [],
        };
        console.log(arr);
        // 处理条件开始流程
        arr = { ...arr, ...this.dataTransform(tree.type, tree) };
        arr.flowNodes = [];
        console.log(tree);
        console.log(arr);
      } else {
        console.log(arr);
        tree.pid = pid;
        arr.flowNodes.push(this.dataTransform(tree.type, tree));

        console.log(arr);
      }
    }
    if (!tree.childNode) {
      this.treeArrToAllArr(arr, type);
      return arr;
    } else {
      return this.treeToArr(tree.childNode, arr, type, tree.id);
    }
  }

  treeArrToAllArr(arr: any, type: any) {
    if (type === 1) {
      arr.course.forEach((item: any) => {
        if (item.conditionNodes && item.conditionNodes.length > 0) {
          item.conditionUnits = [];
          item.conditionNodes.forEach((_item: any, _index: any) => {
            item.conditionUnits[_index] = this.treeToArr(_item, {}, 2, 0);
          });
        }
      });
    }
    if (type === 2) {
      arr.flowNodes.forEach((item: any) => {
        if (item.conditionNodes && item.conditionNodes.length > 0) {
          item.conditionUnits = [];
          item.conditionNodes.forEach((_item: any, _index: any) => {
            item.conditionUnits[_index] = this.treeToArr(_item, {}, 2, 0);
          });
        }
      });
    }
  }

  private dataTransform(type: any, item: any) {
    // 数据格式转换 渲染格式 -> 提交格式 直接原值修改或者新存值再传递
    if (type === 1) {
      item.type = 'approve';
      item.label = item.nodeName;
      // item.approveWay = 'once'; // 测试用 sequential：依次审批  all：会签（须所有审批人同意） once：或签（一名审批人同意或拒绝即可） todo 应由节点弹框组件传值到父级数据
    }
    if (type === 2) {
      item.type = 'cope';
      item.label = item.nodeName;
    }
    if (type === 3) {
      item.type = 'handle';
      item.label = item.nodeName;
    }
    if (type === 4) {
      item.type = 'condition';
      item.label = item.nodeName;
    }
    if (type === 5) {
      item.name = item.nodeName;
      // item.conditionGroups = []; // 测试用 todo 应由节点弹框组件传值到父级数据
    }
    return item;
  }

  private release(type: any) {
    // 节点校验
    // const refStr = 'processDesignRef';
    // const ref: any = this.$refs[refStr];
    // ref.saveSet();

    console.log(this.allForm);
    console.log(this.allForm.process.formData.nodeConfig);
    const obj = deepClone(this.allForm.process.formData.nodeConfig);
    console.log(obj);
    const processArr: any = this.treeToArr(obj, {}, 1, 0);
    console.log(this.allForm);
    console.log(processArr);

    const data = this.allForm;
    const formArr: any = [];
    const map: any = {
      CommonInput: 'Input',
      ImageInput: 'Images',
      TextareaInput: 'Text',
      RadioInput: 'Radio',
      ContactsInput: 'ContactPerson',
      PlaceInput: 'Location',
      Equipment: 'facilityList',
      EquipmentStandard: 'facilityStandredList',
    };
    data.form.formData &&
      data.form.formData.forEach((item: any) => {
        const name = item.type;
        formArr.push({
          componentName: map[name],
          props: item.form,
        });
      });

    const dataForm = {
      icon: data.basic.formData.icon,
      themeColor: data.basic.formData.themeColor,
      describe: data.basic.formData.describe,
      editAuthStaffIds: data.basic.formData.editAuthStaffIds, // 管理员id数组
      flowNodeJsonStr: JSON.stringify(processArr), // 流json
      formControlJsonArrStr: JSON.stringify(formArr), // 表单json
      groupId: data.basic.formData.groupId,
      name: data.basic.formData.name,
      startAuthOrgMember: data.basic.formData.startAuthOrgMember, // 发起人对象数组
    };

    console.log(dataForm);

    if (type === 'add') {
      processServe
        .addFlowForm(dataForm)
        .then((res: any) => {
          console.log(res);
          if (res.code === '200') {
            this.back();
          }
        })
        .catch((e: any) => {
          console.log(e);
        });
    }
    if (type === 'edit') {
      processServe
        .editFlowForm(dataForm, this.editData.id)
        .then((res: any) => {
          console.log(res);
          if (res.code === '200') {
            this.back();
          }
        })
        .catch((e: any) => {
          console.log(e);
        });
    }
  }
}
